import { Option } from "@/common/types/option";
import {
  ActualEntryFilterNode,
  ActualEntryFilterOptionsResponse,
} from "../types/maintenanceWorkflowActualEntryFilter.type";

export interface ForwardingEntryTypeFilter {
  relation: string;
  label: string;
  filterKey: string;
  options: Option[];
}

export interface ActualEntryFilters {
  tree: ActualEntryFilterNode[];
  entryTypeFilters: ForwardingEntryTypeFilter[];
}

const relationFilterKey: Record<string, string> = {
  checkin_entry: "checkinEntryType",
  establishment_choice_entry: "establishmentChoiceEntryType",
  financial_review_entry: "financialReviewEntryType",
  directive_entry: "directiveEntryType",
  fiscal_assessment_entry: "fiscalAssessmentEntryType",
  checkout_entry: "checkoutEntryType",
};

const treeToNodes = (tree?: ActualEntryFilterOptionsResponse): ActualEntryFilterNode[] =>
  Object.entries(tree || {}).map(([label, node]) => ({
    label,
    value: node.value,
    children: node.children ? treeToNodes(node.children) : undefined,
  }));

const nodesToEntryTypeFilters = (nodes: ActualEntryFilterNode[]): ForwardingEntryTypeFilter[] =>
  nodes.map((node) => ({
    relation: node.value.relation,
    label: node.label,
    filterKey: relationFilterKey[node.value.relation],
    options: (node.children || []).map((child) => ({
      label: child.label,
      value: child.value.entry_klass as string,
    })),
  }));

export class MaintenanceWorkflowFiltersTransformer {
  static statusOptionsTransformer() {
    return (statuses?: Record<string, string>): Option[] =>
      Object.entries(statuses || {}).map(([label, value]) => ({ label, value }));
  }

  static actualEntryFiltersTransformer() {
    return (tree?: ActualEntryFilterOptionsResponse): ActualEntryFilters => {
      const nodes = treeToNodes(tree);
      return { tree: nodes, entryTypeFilters: nodesToEntryTypeFilters(nodes) };
    };
  }
}
